<template>
  <div
    :class="[
      {
        must: fieldObj.required == 1,
        err: fieldObj.dirty && fieldObj.invalid
      },
      fieldStyle
    ]"
  >
    <div class="m-input-content">
      <div v-if="fieldStyle == 'style1-wap'" class="u-label">
        {{ fieldObj.displayName }}
      </div>
      <div
        v-if="fieldStyle == 'style2-wap'"
        class="opacityText opacity-selsect-wap  mr24"
      >
        {{ fieldObj.displayName }}
      </div>
      <div class="m-select">
        <a-select
          v-if="fieldObj.isCascade != 1"
          :placeholder="fieldStyle == 'style1-wap' ? '请选择' : ''"
          ref="selectref"
          :allowClear="true"
          :showArrow="true"
          v-model="fieldObj.value"
          @change="handleChange"
          @focus="handleFocus"
          @blur="handleBlur"
          :disabled="fieldObj.disabled"
          :open="selectIsOpen"
        >
          <div slot="suffixIcon">
            <a-icon
              type="down"
              :class="{ 'rotate90-r': moved && fieldStyle == 'style2-wap' }"
            />
          </div>
          <a-select-option
            v-for="o in fieldObj.listOptions"
            :key="o.optionId"
            :value="o.optionId"
          >
            {{ o.optionValue }}
            <input
              ref="inputref"
              class="otherInput"
              v-if="o.otherisFillIn == 1"
              type="text"
              v-model="o.otherValue"
              @blur="inputBlur($event, o)"
              @click.stop="inputClick($event, o.optionId)"
              @input="textChange($event, o.optionId)"
            />
          </a-select-option>
        </a-select>
        <a-cascader
          v-if="fieldObj.isCascade == 1"
          :options="fieldObj.cascaderList"
          v-model="fieldObj.label"
          @change="dicListChange"
          @focus="handleFocus"
          @blur="handleBlur"
          :placeholder="fieldStyle == 'style1-wap' ? '请选择' : ''"
          :field-names="fieldNames"
          :disabled="fieldObj.disabled"
        >
          <div slot="suffixIcon">
            <a-icon
              type="down"
              :class="{ 'rotate90-r': moved && fieldStyle == 'style2-wap' }"
            />
          </div>
        </a-cascader>
        <div
          v-if="fieldStyle == 'style2-wap'"
          class="u-label select-label mr24"
          :class="{
            'select-moved': moved || fieldObj.value.length
          }"
        >
          {{ fieldObj.displayName }}
        </div>
      </div>
    </div>

    <div class="u-reg-err-tips" v-if="fieldObj.dirty && fieldObj.invalid">
      {{ fieldObj.validationMessage }}
    </div>
  </div>
</template>

<script>
import selectMixin from "../../field/new-fields/select";
export default {
  name: "sk-select-wap",
  props: {
    fieldStyle: {
      type: String,
      default: "style1-wap"
    }
  },
  mixins: [selectMixin]
};
</script>
